import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useBanksList() {
  // Use toast
  const toast = useToast();

  const refBankListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "sort_order", label: "排序", sortable: true },
    { key: "name", stickyColumn: true, label: "銀行名稱" },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const banksList = ref(null);


  const dataMeta = computed(() => {
    const localItemsCount = refBankListTable.value
      ? refBankListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refBankListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery ],
    () => {
      refetchData();
    }
  );

  const fetchBanks = (ctx, callback) => {
    store
      .dispatch("bank/fetchBanks", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { banks, total } = response.data;
        callback(banks);
        totalRow.value = total;
        banksList.value = banks

      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  onMounted(() => {
  });

  return {
    fetchBanks,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    banksList,
    refBankListTable,
    ability,
    refetchData,
   
  };
}
